import { useMemo } from 'react'
import { useGrowthBookValues } from '../contexts/GrowthBookContext'

export const useSteps = () => {
  const { steps: stepVariation, attributeSelectionStyle } = useGrowthBookValues()

  // Функция для определения, какие шаги показывать
  const getActiveSteps = useMemo(() => {
    // В create-friend-white нет каруселей и step4_5
    // Только поддержка SHORT режима (убирает step3 и step4)

    console.log('stepVariation', stepVariation)
    if (stepVariation === 'SHORT') {
      // SHORT режим: убираем step3 и step4
      return allSteps => allSteps.filter(step => step !== 'step3' && step !== 'step4')
    }

    // BASE режим: показываем все шаги как есть
    return allSteps => allSteps
  }, [stepVariation])

  // Функция для проверки, является ли режим SHORT
  const isShortMode = useMemo(() => {
    return stepVariation === 'SHORT'
  }, [stepVariation])

  // Функция для проверки, является ли режим CARROUSEL (не используется в white)
  const isCarouselMode = useMemo(() => {
    return false
  }, [])

  return {
    stepVariation,
    attributeSelectionStyle,
    getActiveSteps,
    isShortMode,
    isCarouselMode,
  }
}
